import { useEffect, useState } from "react";
import api from "../lib/api";
import { ScrollText } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2"><ScrollText className="h-6 w-6 text-[#EAB308]" /><h1 className="font-head text-2xl font-bold">Audit Log</h1></div>
      <div className="nnx-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[#64748B] border-b border-[#222B3D]">
            {["Waktu", "User", "Aksi", "Entity", "Detail"].map((h) => <th key={h} className="px-3 py-2.5 text-xs uppercase tracking-wider whitespace-nowrap">{h}</th>)}
          </tr></thead>
          <tbody data-testid="audit-table-body">
            {logs.length === 0 ? <tr><td colSpan={5} className="text-center py-10 text-[#64748B]">Belum ada aktivitas</td></tr> :
              logs.map((l, i) => (
                <tr key={i} className="border-b border-[#222B3D]/60">
                  <td className="px-3 py-2.5 text-xs text-[#94A3B8] whitespace-nowrap">{new Date(l.timestamp).toLocaleString("id-ID")}</td>
                  <td className="px-3 py-2.5 whitespace-nowrap">{l.user_name}</td>
                  <td className="px-3 py-2.5"><span className="text-xs font-medium text-[#EAB308]">{l.action}</span></td>
                  <td className="px-3 py-2.5 mono text-xs">{l.entity_type} {l.entity_id}</td>
                  <td className="px-3 py-2.5 text-xs text-[#94A3B8] max-w-xs truncate">
                    {l.reason ? `${l.reason} ` : ""}{l.new_value ? JSON.stringify(l.new_value) : ""}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
